import { Alert, Box } from '@digibee/beehive-ui';
import map from 'lodash/map';
import React, { FC } from 'react';
import styled from 'styled-components';

import ValidationPropTypes from '../../common/ValidationPropTypes';

import i18n from '~/common/helpers/i18n';

// Locals

const List = styled.div``;

const Item = styled.div`
  margin-bottom: 5px;
`;

interface AlertObjectsProps {
  objects?: string[];
}

const AlertObjects: FC<AlertObjectsProps> = ({ objects = [] }) => (
  <List>
    {objects?.map(object => (
      <Item key={object}>{object}</Item>
    ))}
  </List>
);

type ValidationPropTypes = {
  code: string;
  message: string;
  details: [
    {
      level: string;
      details: string[];
      code: string;
      message: string;
      objects: string[];
    }
  ];
};

interface DeploymentValidationV2Props {
  validation?: ValidationPropTypes[];
  pipelineId?: string;
}

function customPipelineError(detail: any, pipelineId?: string) {
  if (
    detail.code === 'DGB-161' &&
    detail.message === 'Pipeline spec size exceeded.'
  ) {
    const canvaUrl = pipelineId
      ? `https://staging.portal.stg.digibee.dev/staging/design/v2/pipelines/${pipelineId}`
      : 'https://staging.portal.stg.digibee.dev/staging/design/v2/pipelines/';
    return {
      ...detail,
      jsxTitle: (
        <>{i18n.t('label.pipeline_has_error_generic_msg_error_learn_more')}</>
      ),
      jsxContent: (
        <>
          {detail.details?.[1] && (
            <div>
              {detail.details[1]}{' '}
              <a
                href={canvaUrl}
                target='_blank'
                rel='noopener noreferrer'
                style={{ textDecoration: 'underline' }}
              >
                {i18n.t('label.review_here_generic_msg_error')}
              </a>
            </div>
          )}
        </>
      )
    };
  }

  return {
    ...detail,
    jsxTitle: detail.message,
    jsxContent: <AlertObjects objects={detail.objects} />
  };
}

const DeploymentValidationV2: FC<DeploymentValidationV2Props> = ({
  validation,
  pipelineId
}) => (
  <>
    {map(validation, item =>
      map(item?.details, detail => {
        const customDetail = customPipelineError(detail, pipelineId);
        return (
          <Box key={customDetail.message} css={{ marginBottom: '$2' }}>
            <Alert
              key={customDetail.message}
              // @ts-expect-error
              variant={
                customDetail?.level?.toLowerCase() === 'error'
                  ? 'danger'
                  : customDetail?.level?.toLowerCase()
              }
              collapsible
              title={customDetail.jsxTitle}
              content={customDetail.jsxContent}
            />
          </Box>
        );
      })
    )}
  </>
);

export default DeploymentValidationV2;
